export const ENV = {
  API_URL: import.meta.env.VITE_API_URL as string,
  PAYPAL_CLIENT_ID: import.meta.env.VITE_PAYPAL_CLIENT_ID as string,
  PAYPAL_CURRENCY: (import.meta.env.VITE_PAYPAL_CURRENCY as string) || 'MXN'
};
